/* eslint-disable array-callback-return */
import { useEffect, useState } from 'react';
import { CloseRounded } from '@mui/icons-material';
import { Box } from '@mui/material';
import dayjs from 'dayjs';

import { Meeting, ReuniaoComMesAno } from '../../../../services/requests';

import { Container, SectionHeaderDrawer, TabButton, Title } from './styles';
import { MeetingCard } from './MeetingCard';

dayjs().format();

export interface RecurrenceListProps {
  recurrencesList: Meeting[];
  handleCancel: any;
}

export const RecurrenceList = ({
  recurrencesList,
  handleCancel,
}: RecurrenceListProps) => {
  const [listagemReunioesFuturas, setListagemReunioesFuturas] = useState<
    ReuniaoComMesAno[]
  >([]);
  const [listagemReunioesPassadas, setListagemReunioesPassadas] = useState<
    ReuniaoComMesAno[]
  >([]);
  const [tabSelected, setTabSelected] = useState('futuras');

  useEffect(() => {
    if (recurrencesList && recurrencesList?.length > 0) {
      let pastRecurrence: any[] = [];
      let futureRecurrence: any[] = [];

      recurrencesList?.map(m => {
        const horarioFinalCorreto = dayjs(m.start_at)
          .add(m.duration, 'minutes')
          .toDate();

        const mes = dayjs(m?.start_at).format('MM');
        const ano = dayjs(m?.start_at).format('YYYY');
        const horaInicial = dayjs(m?.start_at).format('HH:mm A');
        const horaFinal = dayjs(horarioFinalCorreto).format('HH:mm A');

        const today = new Date();

        if (horarioFinalCorreto > today) {
          futureRecurrence = [
            ...futureRecurrence,
            {
              ...m,
              horaInicial,
              horaFinal,
              mes,
              ano,
            },
          ];
        } else {
          pastRecurrence = [
            ...pastRecurrence,
            {
              ...m,
              horaInicial,
              horaFinal,
              mes,
              ano,
            },
          ];
        }
      });

      setListagemReunioesFuturas(futureRecurrence as any);
      setListagemReunioesPassadas(pastRecurrence as any);
    }
  }, [recurrencesList]);

  const handleCheck = (type: string) => {
    setTabSelected(type);
  };

  return (
    <Box
      sx={{
        width: '480px',
        height: '100%',
        padding: '20px',
        position: 'relative',
      }}
    >
      <SectionHeaderDrawer>
        <CloseRounded
          sx={{ cursor: 'pointer', position: 'absolute', left: '0' }}
          onClick={handleCancel}
        />
        <Title>Reuniões recorrentes</Title>
      </SectionHeaderDrawer>
      <Box sx={{ marginTop: '20px' }}>
        <Box sx={{ marginTop: '20px' }}>
          <TabButton
            onClick={() => handleCheck('futuras')}
            variant="text"
            className="btn-meetings-futures"
            active={tabSelected === 'futuras'}
          >
            FUTURAS
          </TabButton>
          <TabButton
            active={tabSelected === 'passadas'}
            className="btn-meetings-previous"
            onClick={() => handleCheck('passadas')}
          >
            PASSADAS
          </TabButton>
        </Box>

        <Box sx={{ padding: '0' }}>
          {tabSelected === 'futuras' && (
            <Container>
              {listagemReunioesFuturas?.length > 0 &&
                listagemReunioesFuturas?.map(r => (
                  <MeetingCard key={r?.id} meeting={r} />
                ))}
            </Container>
          )}
          {tabSelected === 'passadas' && (
            <Container>
              {listagemReunioesPassadas?.length > 0 &&
                listagemReunioesPassadas?.map(r => (
                  <MeetingCard key={r?.id} meeting={r} />
                ))}
            </Container>
          )}
        </Box>
      </Box>
    </Box>
  );
};
